import {
  IFileData,
  ISQLSeedingTranslator,
} from '@principle-theorem/practice-migrations/interfaces';
import { IProvider } from '@principle-theorem/shared';

export class PraktikaQuoteProceduresTranslator
  implements ISQLSeedingTranslator, IProvider<IFileData, string[]>
{
  matchingFilenames = ['quote_procedures.csv'];
  commands = [
    `sed -i -e 's/iStatusId/iStatusId2/2'`,
    `sed -i -e 's/quote_for_export/quote_for_export2/2'`,
    `sed -i -e 's/quote_for_export/quote_for_export3/3'`,
  ];

  canProvide(data: IFileData): boolean {
    return this.matchingFilenames.includes(data.fileName);
  }

  execute(data: IFileData): string[] {
    return this.commands.map((cmd) => `${cmd} ${data.filePath}`);
  }
}
